module.exports = __webpack_public_path__ + "static/media/home-news-img2.a1e6dea0.jpg";